import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import HeroActionInfo from '../../PrincipalPaydown/components/Hero/HeroActionInfo';
import ListWithAction from '../../PrincipalPaydown/components/ListWithAction';

import invoice from '../../../assets/images/invoice.png';
import purchaseOrder from '../../../assets/images/purchase-order.png';
import {invoiceDocuments, purchaseOrderDocuments} from '../misc/tradeDocumentExamples';
import Formatters from '../../shared/utils/Formatters';
import { isExpiringWithinDays } from '../../shared/utils/DateCalculations';

const propTypes = {
  creditRemaining:          PropTypes.number.isRequired,
  hasOverdue:               PropTypes.bool.isRequired,
  loading:                  PropTypes.bool.isRequired,
  trackClick:               PropTypes.func.isRequired,
  redirectTo:               PropTypes.func.isRequired,
  endTimestamp:             PropTypes.string,
  upcomingRclTimestamp:     PropTypes.string,
};

const TradeDocuments = ({ 
  creditRemaining, 
  hasOverdue, 
  loading, 
  trackClick, 
  redirectTo, 
  endTimestamp, 
  upcomingRclTimestamp
}) => {

  const onActionClick = actionName => {
    if (actionName === 'invoices') trackClick('upload_invoice');
    if (actionName === 'purchase_orders') trackClick('upload_po');

    redirectTo(`/${actionName}/new`);
  }

  const onHeroActionClick = () => redirectTo('/account');

  const infoText = () => {
    return '*Due to the COVID-19 situation, we will review applications on a case-to-case basis. ' +
      'The amount here is a guide and not a guarantee.';
  }

  const daysBeforeExpiry = 30
  let reApplyDate = moment.tz(endTimestamp,'Asia/Manila').subtract(daysBeforeExpiry, 'days')
  reApplyDate = Formatters.date(reApplyDate)

  const renewalDateHeader = () => {
    return (
      <span> Reapply for a
        <strong class='-primary'> Revolving Credit Line </strong>
        starting <br/>
        <span data-testid="reapply-date"> {reApplyDate} </span>
        to keep accessing additional funds.
      </span>
    )
  }

  const headerForNonRclUsers = () =>{
    return (
      <span>
        Get access to additional funds <br />
        with a <strong className='-primary'>Revolving Credit Line</strong>
      </span>
    );
  }
  
  const formatted_upcoming_start_date = Formatters.date(upcomingRclTimestamp)
  const headerForUsersWithUpcomingRCL = () =>{
    return (
      <span>
        Your new <strong className='-primary'>Revolving Credit Line</strong> is
        starting on <br />
        <span>{formatted_upcoming_start_date}.</span>
      </span>
    );
  }

  const isExpiringOrNoRcl =
    !endTimestamp || isExpiringWithinDays(endTimestamp, daysBeforeExpiry);

  const expiringOrHasUpcomingHeader = !!upcomingRclTimestamp
    ? headerForUsersWithUpcomingRCL()
    : headerForNonRclUsers();

  const heroActionHeaderText = isExpiringOrNoRcl
    ? expiringOrHasUpcomingHeader
    : renewalDateHeader();
  
  const invoiceSubheadText = 'Get paid for any receivable'
  const purchaseOrderSubheadText = 'Fund any unfulfilled orders'

  const uploadPOBtn = isExpiringOrNoRcl
    ? 'Upload a Purchase Order'
    : 'Upload a p.o.';
  const uploadIVBtn = isExpiringOrNoRcl
    ? 'Upload an Invoice'
    : 'Upload an invoice';

  const invoiceClickAction = (that) => {
    return isExpiringWithinDays(endTimestamp, daysBeforeExpiry) ?
      onActionClick.bind(that, 'invoices') : false
  }

  const purchaseOrderClickAction = (that) => {
    return isExpiringWithinDays(endTimestamp, daysBeforeExpiry) ?
      onActionClick.bind(that, 'purchase_orders') : false
  }

  const cardClassName = isExpiringOrNoRcl
    ? '_verticalBorder--none'
    : '_borderBottom--medium';

  return (
    <div className='ds-card' data-testid='trade-doc-upload-card'>
      <HeroActionInfo
        cardClassName={cardClassName}
        headerText={heroActionHeaderText}
        amount={creditRemaining}
        emphasisCharacter='*'
        hasOverdue={hasOverdue}
        actionType='anchor'
        actionLabel='Understand your limit'
        onClick={onHeroActionClick}
        infoText={infoText()}
        loading={loading}
        dataPath='/account'
        headerOnly={isExpiringOrNoRcl}
      />
      <div className='cardSection _verticalPadding--none _horizontalPadding--none _withColumns _justifyContent-center _alignItemsInitial'>
        <ListWithAction
          imageUrl={invoice}
          headline='Collect your unpaid invoices'
          subhead={invoiceSubheadText}
          listHeader='We also accept:'
          listItems={invoiceDocuments}
          listClassName={'_padding--xxsmall'}
          icon='check_circle'
          actionLabel={uploadIVBtn}
          onActionClick={invoiceClickAction(this)}
          cardClassName='_borderRight--medium'
          buttonClassName='_marginTop--auto'
          dataTestId='upload-invoice-btn'
        />
        <ListWithAction
          imageUrl={purchaseOrder}
          headline='Take on more orders'
          subhead={purchaseOrderSubheadText}
          listHeader='We also accept:'
          listItems={purchaseOrderDocuments}
          listClassName={'_padding--xxsmall'}
          icon='check_circle'
          actionLabel={uploadPOBtn}
          onActionClick={purchaseOrderClickAction(this)}
          cardClassName='_displayFlex _flexColumn'
          buttonClassName='_marginTop--auto'
          dataTestId='upload-po-btn'
        />
      </div>
    </div>
  );
}

TradeDocuments.propTypes = propTypes;
export default TradeDocuments;



// WEBPACK FOOTER //
// ./src/features/applyNow/components/TradeDocuments.js